import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useDtpDetailModel } from "./dtpDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useDictModel } from "@/views/base/dict/dictModel";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal, insertOrUpdateDtp, getDtpDetailOne, resetPageCache } = useDtpDetailModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            getDtpDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("2-1-1") && resetPageCache("add")
            !findNav("2-1-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "询价单号",
            value: editFormVal.code ?? "无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(editFormVal.status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "状态",
        //     value: getTreeNodeName(editFormVal.status ?? ""),
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
    ]


    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            insertOrUpdateDtp(mode, val).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("2-1-1", "2-1-2", { id: res as string, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "2-1")}
        >返回</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { onSubmit() }}
        >保存</Button>
    </>

    return (
        <YhBox
            title={orderStatu.map((item, index) => <Description key={index} {...item} />)}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}